<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_POSITION_ADD"
            @click.stop="handleAdd()"
          >新增</el-button>
          <el-button
            type="warning"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_POSITION_DEL"
            @click.stop="handleDel('DELETE_OPTION','逻辑删除')"
          >删除</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_POSITION_DEL_TRUE"
            @click.stop="handleDel('DELETE_OPTION','物理删除')"
          >物理删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_POSITION_EDIT"
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="showDialog(scope.row)"
          >权限</el-button>
        </template>
        <template slot-scope="scope" slot="departId">
          <el-tag v-if="scope.row.departName != null">{{scope.row.departName}}</el-tag>
        </template>
        <template slot-scope="scope" slot="departIdForm">
          <el-select v-model="depart" placeholder="请选择所属部门" required value-key="id">
            <el-option
              v-for="depart in departs"
              :key="depart.id"
              :label="depart.name"
              :value="depart"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
      <el-dialog
        title="权限菜单"
        :visible.sync="dialogVisible"
        width="50%"
        :data="dialog"
        style="background-color: #4E5465"
      >
        <el-tree
          :data="selectRolePermissions"
          ref="tree"
          default-expand-all
          show-checkbox
          check-strictly
          node-key="id"
        ></el-tree>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updatePosition()">确 定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { positionTableOption } from "@/const/salesCloud/positionOption";
import {
  findPosition,
  addPosition,
  editPosition,
  delPosition,
  permissionMenusByDepart,
  permissionMenusByPosition
} from "@/api/salesCloud/position";
import { findDepartmentAll } from "@/api/salesCloud/department";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "position",
  components: {},
  data() {
    return {
      tableOption: positionTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      departs: [],
      depart: {},
      dialogVisible: false,
      dialog: {},
      selectRolePermissions: []
    };
  },
  created() {
    // 查询部门
    findDepartmentAll().then(res => {
      let data = JSON.parse(res.data);
      this.departs = data;
    });

    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findPosition(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findPosition(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findPosition(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findPosition(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      if (null != row.departId) {
        this.depart = {
          id: row.departId
        };
      }
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findPosition(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.departId = this.depart.id;
      addPosition(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delPosition(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.departId = this.depart.id;
      editPosition(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    showDialog(row) {
      this.dialog.id = row.id;
      this.dialog.departId = row.departId;
      let _this = this;
      permissionMenusByDepart(row.departId).then(res => {
        let data = JSON.parse(res.data);
        this.selectRolePermissions = data;
        console.log(this.selectRolePermissions);
        permissionMenusByPosition(row.id).then(res => {
          let data = JSON.parse(res.data);
          _this.$refs.tree.setCheckedKeys(data, true);
          console.log("数据：" + res.data);
        });
      });
      this.dialogVisible = true;
    },
    updatePosition() {
      let checkKeys = [].concat(
        this.$refs.tree.getHalfCheckedKeys(),
        this.$refs.tree.getCheckedKeys()
      );
      let data = {};
      data.id = this.dialog.id;
      data.departId = this.dialog.departId;
      data.menuIds = checkKeys;
      editPosition(data)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.dialogVisible = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      console.log("数据：" + JSON.stringify(checkKeys));
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
